import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'app/shared/services/api.service';
import { HttpClient } from '@angular/common/http';
import { Jobs } from 'app/shared/models/jobs.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { environment } from 'environments/environment';
import { NgSelectModule } from "@ng-select/ng-select";

@Component({
  selector: 'app-add',
  templateUrl: './model.component.html',
  styleUrls: ['./model.component.scss']
})
export class ModelComponent implements OnInit {
  @ViewChild('vform') validationForm: FormGroup;
  referenceForm: FormGroup;
  modelForm: FormGroup;
  fileData: File
  jobsFormSubmitted: boolean = false;
  selectedSkill: string[] = [];
  selectedowner: string = '';
  selectedproject_tag: string = '';
  selectedchecklist: string = '';
  selectedauditor: string = '';
  selectedpublisher: string = '';
  selectedmarketer: string = '';
  tagsList = []
  skillId = '6319d3595ab9e462a96cfb06'
  teamList = []
  selectedTeam: string[] = [];
  ipAddress: any
  currentUrl: any
  jobs_id: any
  jobs_data: any
  jobs_model = new Jobs()
  isEdit: boolean = false
  referenceList = []
  selectedRef: string[] = [];
  reference_id: any
  reference_model = {
    refId: '',
    name: '',
    links: '',
    description: '',
    IP: '',
    notes: '',
    admin_notes: ''
  }
  jobModel:any = {
    name: '',
    skills: [],
    team: [],
    projectbudget: '',
    rate: '',
    engage_tags:'',
    IP: '',
    description: '',
    references: [],
    notes: '',
    admin_notes: '',
    alert_notes: '',
    Communication: '',
    sprints: '',
    mom: '',
    dmsfrs: '',
    kpi: '',
    reports: '',
    workdairy: '',
    bitbucket: '',
    demo: '',
    qa: '',
    crequest: '',
    hunting_by: [],
    farming_by: [],
    source: '',
    technology: '',
    channel: '',
    isalert: '',
    priority: '',
    status: '',
    feature:'',
    workon:'',
    owner: '',
    auditor: '',
    publisher: '',
    marketer: '',
    project_tag: '',
    checklist:'',
    codeName:'',
    developmentStage:[],
    marketStage:[],
    configState:[],
    modelCategory:[],
    domain:'',
    modelVariant :[],
    modelSource:[],
    config_notes:'',
    demo_notes :''
  }

  sourceList = [];
  source_tagcat_id = '63ef44bb5fb91668b7f123ba'
  source_name: any = 'upwork'
  selected_source = '63ef45065fb91668b7f123c3'

  channelList = []
  channel_id_upwork = '63f89955c3648e0879c3e068'
  channel_id_fiverr = '63f89982c3648e0879c3e06f'
  channel_id_direct = '63f899a5c3648e0879c3e076'
  selected_channel: any

  selectedTechnology = null
  technology_catId = '6319d5025ab9e462a96cfbba'
  technology_List = []

  usersList: []
  selectedHuntingBy: string[] = [];
  selectedFarmingBy: string[] = [];

  alert_list = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' },
  ]
  alert_event = 'no'

  engage_tagcat_id = '66cc36c9866da48baa275811'
  engage_tags_list = []
  selected_engage_tags:any = null
  selectedUploadType:any
  selectedImage: File | null = null;
  selectedImages: File[] = [];
  jobType_list=[
    {name:'Bundle',id:'68726dab63f8ad388585ab3b'},
    {name:'Project',id:'644a5c52af0db342c32eeaf8'},
    {name:'Product',id:'644a5c84af0db342c32eeb02'},
  ]
  selected_job_type =null
  current_type:any
  project_source_cat_id = '685970b6de9510031e95875e'
  project_tags_tagcat_id ='685971ad7bf67c03258f6740'
  project_source_list = []
  project_tags_list = []
  check_list = []
  base_url = environment.apiUrls.s3MediaUrl
  development_stage_cat_id='686f7ebc00effa369376c945'
  market_stage_cat_id ="686f7ece0b29da3695eda22b"
  config_state_cat_id ="686f7ee1bd3763368cd65444"
  model_cat_id ="686f7eef00effa369376c947"
  model_source_cat_id ="686f7f160b29da3695eda22f"
  model_varient_cat_id ="686f7f021b1589368b37e706"
  development_stage_list= []
  selected_development_stage = null
  market_stage_list=[]
  selected_market_stage = null
  config_state_list=[]
  selected_config_state = null
  model_cat_list=[]
  selected_model_cat = null

  model_source_list=[]
  selected_model_source = null

  model_varient_list =[]
  selected_model_varient = null
  constructor(private formBuilder: FormBuilder, private http: HttpClient,
    public toastr: ToastrService, private activerouter: ActivatedRoute,
    public apiService: ApiService, private route: Router,
    private modalService: NgbModal,) {
    this.currentUrl = this.activerouter.snapshot.routeConfig.path
    this.activerouter.paramMap.subscribe(params => {
      this.jobs_id = params.get('id');
    })
    this.activerouter.queryParams
      .subscribe((params: any) => {
      this.current_type = params['type'];
      if(this.current_type === 'project'){
        this.selected_job_type = this.jobType_list[1].id
        this.jobModel.workon = this.selected_job_type
        this.getProjectSource()
        this.getProjectTags()
        this.selected_source = null

      }    
    })
  }

  ngOnInit() {
    if (this.currentUrl == 'model/edit/:id' && this.jobs_id) {
      this.getJobsById()
    }

    this.getSkillTagByCategory()
    this.getTeamList()
    this.modelForm = this.formBuilder.group({
      name: ['', Validators.required],
      codename:['',],
      skills: ['',],
      team: ['',],
      projectbudget: ['',],
      rate: ['',],
      IP: ['',],
      description: ['',],
      references: ['',],
      Communication: ['',],
      sprints: ['',],
      mom: ['',],
      dmsfrs: ['',],
      kpi: ['',],
      reports: ['',],
      workdairy: ['',],
      bitbucket: ['',],
      demo: ['',],
      qa: ['',],
      crequest: ['',],
      alert_notes: ['',],
      notes: ['',],
      admin_notes: ['',],
      feature: ['',],
      owner: ['',],
      auditor: ['',],
      publisher: ['',],
      marketer: ['',],
      project_tag: ['',],
      demo_notes:['',],
      config_notes:['',],
      domain:['',]
    })
    this.referenceForm = this.formBuilder.group({
      name: ['',],
      links: ['',],
      description: ['',],
      IP: ['',],
      notes: ['',],
      admin_notes: ['',]
    })
    this.getSource()
    this.getTechnologyList()
    this.getUsers()
    this.getEngageList()
    this.getProjectSource()
     this.getDevelopment()
    this.getMarket()
    this.getConfig()
    this.getModelCat()
    this.getModelSource()
    this.getModelVarient()
    this.getChecklist()
  }
  get rf() {
    return this.modelForm.controls;
  }

  getJobsById() {
    this.apiService.getModelManagementById(this.jobs_id).subscribe((res: any) => {
      for (let item of res?.data) {
        this.jobs_model = item
        this.jobModel.image = item?.image
        if(item?.workon[0]?._id){
          this.selected_job_type = item?.workon[0]?._id
        }
        
      }
      // console.log('job =>>',this.jobs_model)
      this.jobModel.name = this.jobs_model?.name
      this.jobModel.projectbudget = this.jobs_model?.projectbudget
      this.jobModel.IP = this.jobs_model?.IP
      this.jobModel.description = this.jobs_model?.description
      this.jobModel.Communication = this.jobs_model?.Communication
      this.jobModel.bitbucket = this.jobs_model?.bitbucket
      this.jobModel.crequest = this.jobs_model?.crequest
      this.jobModel.demo = this.jobs_model?.demo
      this.jobModel.dmsfrs = this.jobs_model?.dmsfrs
      this.jobModel.kpi = this.jobs_model?.kpi
      this.jobModel.mom = this.jobs_model?.mom
      this.jobModel.qa = this.jobs_model?.qa
      this.jobModel.reports = this.jobs_model?.reports
      this.jobModel.sprints = this.jobs_model?.sprints
      this.jobModel.workdairy = this.jobs_model?.workdairy
      this.alert_event = this.jobs_model?.isalert

      this.jobModel.notes = this.jobs_model?.notes
      this.jobModel.admin_notes = this.jobs_model?.admin_notes
      this.jobModel.alert_notes = this.jobs_model?.alert_notes
      this.jobModel.isalert = this.jobs_model?.isalert

      this.selectedproject_tag = (this.jobs_model?.project_tag as any)?._id || ''
      this.jobModel.project_tag = this.selectedproject_tag
      console.log('this.jobModel.selectedproject_tag',this.jobModel.selectedproject_tag)

      this.selectedowner = (this.jobs_model?.owner as any)?._id || ''
      this.jobModel.owner = this.selectedowner
      console.log('this.jobModel.owner',this.jobModel.owner)
      this.selectedauditor = (this.jobs_model?.auditor as any)?._id || ''
      this.jobModel.auditor = this.selectedauditor
      console.log('this.jobModel.auditor',this.jobModel.auditor)
      this.selectedpublisher = (this.jobs_model?.publisher as any)?._id || ''
      this.jobModel.publisher = this.selectedpublisher
      console.log('this.jobModel.publisher',this.jobModel.publisher)
      this.selectedmarketer = (this.jobs_model?.marketer as any)?._id || ''
      this.jobModel.marketer = this.selectedmarketer
      console.log('this.jobModel.marketer',this.jobModel.marketer)
      this.jobModel.codeName = this.jobs_model?.codeName
       this.jobModel.domain= this.jobs_model?.domain
       this.jobModel.config_notes = this.jobs_model?.config_notes
       this.jobModel.demo_notes= this.jobs_model?.demo_notes
       this.selected_development_stage = (this.jobs_model?.developmentStage as any)?._id || ''
      this.jobModel.developmentStage = this.selectedmarketer
      this.selected_market_stage = (this.jobs_model?.marketStage as any)?._id || ''
      this.jobModel.marketStage = this.selected_market_stage
      this.selected_config_state = (this.jobs_model?.configState as any)?._id || ''
      this.jobModel.configState = this.selected_config_state
      this.selected_model_cat = (this.jobs_model?.modelCategory as any)?._id || ''
      this.jobModel.modelCategory = this.selected_model_cat
      console.log('this.jobModel.modelCategory',this.jobModel.modelCategory)
      console.log('this.selected_model_cat',this.selected_model_cat)
      this.selected_model_varient = (this.jobs_model?.modelVariant as any)?._id || ''
      this.jobModel.modelVariant = this.selected_model_varient
      console.log('this.jobModel.modelVariant',this.jobModel.modelVariant)
      console.log(' this.selected_model_varient', this.selected_model_varient)
      this.selected_model_source = (this.jobs_model?.modelSource as any)?._id || ''
      this.jobModel.modelSource = this.selected_model_source

      // Update form values for edit mode
      if (this.modelForm) {
        this.modelForm.patchValue({
          name: this.jobModel.name,
          projectbudget: this.jobModel.projectbudget,
          rate: this.jobModel.rate,
          alert_notes: this.jobModel.alert_notes,
          notes: this.jobModel.notes,
          admin_notes: this.jobModel.admin_notes,
          description: this.jobModel.description,
          feature: this.jobModel.feature
        });
      }
  
      this.selectedSkill = this.jobs_model?.skills?.map((item) => item?._id)
      this.jobModel.skills = this.selectedSkill

      this.selectedHuntingBy = this.jobs_model?.hunting_by?.map((item) => item?._id)
      this.jobModel.hunting_by = this.selectedHuntingBy

      this.selectedFarmingBy = this.jobs_model?.farming_by?.map((item) => item?._id)

      this.jobModel.farming_by = this.selectedFarmingBy

      this.selectedTechnology = this.jobs_model?.technology[0]?._id
      this.jobModel.technology = this.selectedTechnology

      this.selected_channel = this.jobs_model?.channel?._id
      this.jobModel.channel = this.selected_channel

      this.selected_source = this.jobs_model?.source[0]?._id
      this.jobModel.priority = this.jobs_model?.priority[0]?._id
      this.jobModel.status = this.jobs_model?.status[0]?._id
      this.jobModel.rate = this.jobs_model?.rate
      if (this.jobs_model?.engage_tags) {
        this.selected_engage_tags = this.jobs_model?.engage_tags[0]?._id
        this.jobModel.engage_tags = this.selected_engage_tags
      }
      
      if (this.jobs_model?.references?.length > 0) {
        this.referenceList = this.jobs_model?.references?.map((item) => item)
        this.selectedRef = this.referenceList?.map((item) => item?._id)
        // this.jobModel.references=this.selectedRef
      }
      if (this.jobs_id) {
        if (this.source_name == 'upwork') {
          this.getChannelList(this.channel_id_upwork, this.selectedTechnology)
        }
        else if (this.source_name == 'fiverrr') {
          this.getChannelList(this.channel_id_fiverr, this.selectedTechnology)
        }
        else if (this.source_name == 'direct') {
          this.getChannelList(this.channel_id_direct, this.selectedTechnology)
        }
      }
      this.jobModel.description = this.jobs_model?.description
      this.jobModel.feature = this.jobs_model?.feature

      
      if(this.jobModel.image){
        this.selectedUploadType = 'single'
      }
    })
  }
  selectAlert(event) {
    this.alert_event
    this.jobModel.isalert = this.alert_event
  }

  getRefId(event) {
    if (!this.jobs_id && this.currentUrl == 'model') {
      this.selectedRef
      this.jobModel.references = event
    }
    if (this.jobs_id && this.currentUrl == 'model/edit/:id') {
      this.jobModel.references = event
      let data = this.jobModel.references.filter(obj => !('_id' in obj));
      if (data) {
        this.jobModel.references = data
        const newValues = event.filter(value => !this.jobModel.references.some(obj => obj._id === value._id))
        this.jobModel.references.push(...newValues)
      }
    }
  }
  getSkillTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
      this.tagsList = res.data
    })
  }
  getTagsId(event: any) {
    this.selectedSkill
    if (this.jobs_id) {
      this.jobModel.skills = this.selectedSkill
    }
  }
  getTeamList() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.teamList = res.items
    })
  }
  getTeamId(event: any) {
    this.selectedTeam
    if (this.jobs_id) {
      this.jobModel.team = this.selectedTeam
    }
  }
  getSource() {
    this.apiService.getTagByTagCatgoryId(this.source_tagcat_id).subscribe((res: any) => {
      this.sourceList = res.data
    })
  }
  getProjectSource() {
    this.apiService.getTagByTagCatgoryId(this.project_source_cat_id).subscribe((res: any) => {
      this.project_source_list = res.data
    })
  }

  getChecklist() {
    let pageno = 1
    let pagesize = 100
    this.apiService.getchecklist(pageno,pagesize).subscribe((res: any) => {
      this.check_list = res?.data?.items
      console.log('check_list',this.check_list)
    })
  }
  getProjectTags() {
    this.apiService.getTagByTagCatgoryId(this.project_tags_tagcat_id).subscribe((res: any) => {
      this.project_tags_list = res.data
    })
  }
  getSourceId(event: any) {
    this.source_name = event.name
    this.selected_source
    if (this.jobs_id) {
      this.jobModel.source = this.selected_source
    }
    if (this.source_name == 'upwork') {
      this.getChannelList(this.channel_id_upwork, this.selectedTechnology)
    }
    else if (this.source_name == 'fiverrr') {
      this.getChannelList(this.channel_id_fiverr, this.selectedTechnology)
    }
    else if (this.source_name == 'direct') {
      this.getChannelList(this.channel_id_direct, this.selectedTechnology)
    }

  }
  getChannelList(id, tech_id) {
    this.apiService.getChannelsByCategory(id, tech_id).subscribe((res: any) => {
      this.channelList = res.data
    })
  }
  getChangeChannelId(event) {
    this.jobModel.channel = this.selected_channel
  }
  getTechnologyList() {
    this.apiService.getTagByTagCatgoryId(this.technology_catId).subscribe((res: any) => {
      this.technology_List = res.data.slice(0, 4)
    })
  }
  getTechnologyId(event) {
    this.selectedTechnology
    if (this.source_name == 'upwork') {
      this.getChannelList(this.channel_id_upwork, this.selectedTechnology)
    }
    else if (this.source_name == 'fiverrr') {
      this.getChannelList(this.channel_id_fiverr, this.selectedTechnology)
    }
    else if (this.source_name == 'direct') {
      this.getChannelList(this.channel_id_direct, this.selectedTechnology)
    }
    if (this.jobs_id) {
      this.jobModel.technology = this.selectedTechnology
    }
  }
  getUsers() {

    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
      console.log('usersList',this.usersList)
    })
  }
  getOwner() {
    
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
      console.log('usersList',this.usersList)
    })
  }
  getAuditor() {
    
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
      console.log('usersList',this.usersList)
    })
  }
  getPublisher() {
    
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
      console.log('usersList',this.usersList)
    })
  }
  getMarketer() {
    
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
      console.log('usersList',this.usersList)
    })
  }
  getHuntId(event: any) {
    this.selectedHuntingBy
    if (this.jobs_id) {
      this.jobModel.hunting_by = this.selectedHuntingBy
    }
  }
   getEngageList() {
    this.apiService.getTagByTagCatgoryId(this.engage_tagcat_id).subscribe((res: any) => {
      this.engage_tags_list = res.data
    })
  }
  getEngageId(event) {
    this.selected_engage_tags
    if (this.jobs_id) {
      this.jobModel.engage_tags = this.selected_engage_tags
    }
  }
  getFarmId(event: any) {
    this.selectedFarmingBy
    if (this.jobs_id) {
      this.jobModel.farming_by = this.selectedFarmingBy
    }
  }
  submit() {
    this.jobsFormSubmitted = true;

  if (this.modelForm.invalid) {
    this.toastr.error('Please fill all required fields');
    return;
  }
  console.log('this.jobModel.marketer',this.jobModel.marketer)
  console.log('this.jobModel.owner',this.jobModel.owner)
  console.log('this.jobModel.publisher',this.jobModel.publisher)
  console.log('this.jobModel.auditor',this.jobModel.auditor)
    let body = {
      owner: this.jobModel.owner,
      auditor: this.jobModel.auditor,
      publisher: this.jobModel.publisher,
      marketer: this.jobModel.marketer,
      name: this.modelForm.value.name,
      skills: this.selectedSkill,
      projectbudget: this.modelForm.value.projectbudget,
      references: this.jobModel.references,
      isalert: this.alert_event,
      hunting_by: this.selectedHuntingBy,
      farming_by: this.selectedFarmingBy,
      status: '6428038677a2ab2fb559dc36',// current status
      priority: '6428043d77a2ab2fb559dcd9',// normal priority
      source: this.selected_source,
      technology: this.selectedTechnology,
      channel: this.selected_channel,
      alert_notes: this.modelForm.value.alert_notes,
      notes: this.modelForm.value.notes,
      admin_notes: this.modelForm.value.admin_notes,
      rate: this.modelForm.value.rate,
      engage_tags: this.selected_engage_tags,
      description: this.modelForm.value.description,
      feature: this.modelForm.value.feature,
      workon: this.jobModel.workon,
      project_tag: this.jobModel.project_tag,
      checklist: this.jobModel.checklist,
      codeName:this.jobModel.codeName,
    developmentStage:this.jobModel.developmentStage,
    marketStage: this.jobModel.marketStage,
    configState:this.jobModel.configState,
    modelCategory:this.jobModel.modelCategory,
    domain:this.jobModel.domain,
    modelVariant :this.jobModel.modelVariant,
    modelSource:this.jobModel.modelSource,
    config_notes:this.jobModel.config_notes,
    demo_notes :this.jobModel.demo_notes
     
     
    }
    if (this.currentUrl == 'model') {
      // console.log('body', body)
      this.apiService.createmodelmanagement(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.jobs_id = res?.data?._id
          if (this.selectedImage && this.selectedImage !==null || this.selectedImage !==undefined) this.profileImageUpload()
          if(this.selectedImages && this.selectedImages !==null || this.selectedImages !==undefined) this.multiImageUpload()


          // console.log('job create res', res)
          
          this.toastr.success('model management created successfully')
          this.route.navigate(['/jobs/new-projects'], { 
            queryParams: { status: 'current', page: 1 } 
          })        }
        else { this.toastr.error(res.error) }
      })
      this.jobsFormSubmitted = true;
      if (this.modelForm.invalid) {
        return;
      }
    }
    if (this.currentUrl == 'model/edit/:id' && this.jobs_id) {
      // Update jobModel with current form values for edit
      this.jobModel.name = this.modelForm.value.name;
      this.jobModel.projectbudget = this.modelForm.value.projectbudget;
      this.jobModel.rate = this.modelForm.value.rate;
      this.jobModel.alert_notes = this.modelForm.value.alert_notes;
      this.jobModel.notes = this.modelForm.value.notes;
      this.jobModel.admin_notes = this.modelForm.value.admin_notes;
      this.jobModel.description = this.modelForm.value.description;
      this.jobModel.feature = this.modelForm.value.feature;
      
      // Update single value fields
      this.jobModel.owner = this.selectedowner;
      this.jobModel.checklist = this.selectedchecklist;
      this.jobModel.auditor = this.selectedauditor;
      this.jobModel.publisher = this.selectedpublisher;
      this.jobModel.marketer = this.selectedmarketer;
      
      this.jobModel.source = this.selected_source;
      this.jobModel.status = '6428038677a2ab2fb559dc36'; // current job_status
      this.jobModel.workon = this.selected_job_type;
      this.jobModel.skills = this.selectedSkill;
      this.jobModel.hunting_by = this.selectedHuntingBy;
      this.jobModel.farming_by = this.selectedFarmingBy;
      this.jobModel.technology = this.selectedTechnology;
      this.jobModel.channel = this.selected_channel;
      this.jobModel.project_tag = this.selectedproject_tag;
      this.jobModel.engage_tags = this.selected_engage_tags;
      this.jobModel.isalert = this.alert_event;
      
      // --- Fix: Ensure array fields are arrays, not empty strings ---
      const arrayFields = [
        'developmentStage',
        'marketStage',
        'configState',
        'modelCategory',
        'modelVariant',
        'modelSource'
      ];
      arrayFields.forEach(field => {
        if (typeof this.jobModel[field] === 'string') {
          this.jobModel[field] = this.jobModel[field] ? [this.jobModel[field]] : [];
        } else if (!Array.isArray(this.jobModel[field])) {
          this.jobModel[field] = [];
        }
      });

      this.apiService.updateModelManagement(this.jobs_id, this.jobModel).subscribe((res: any) => {
        if (res.statusCode == 200) {
          if (this.selectedImage && this.selectedImage !== null || this.selectedImage !== undefined) this.profileImageUpload();
          if (this.selectedImages && this.selectedImages !== null || this.selectedImages !== undefined) this.multiImageUpload();

          this.toastr.success('model management update successfully');
          this.route.navigate(['/jobs/new-projects'], {
            queryParams: { status: 'current', page: 1 }
          });
        }
        else { this.toastr.error(res.error); }
      });
    }

  }
  back() {
    this.route.navigate(['/jobs/new-projects'], { 
      queryParams: { status: 'current', page: 1 } 
    })
  }
  openModal(content) {
    this.reference_model.IP = this.ipAddress
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submitRef() {

    this.referenceForm = this.formBuilder.group(this.reference_model);
    this.referenceList.push(this.referenceForm.value)
    this.referenceList = this.referenceList.map(item => item)
    this.referenceForm.reset(this.reference_model);
    this.modalService.dismissAll()
  }

  editItem(data, content) {
    this.reference_id = data._id
    this.reference_model.refId = this.reference_id
    this.reference_model.name = data.name
    this.reference_model.links = data.links
    this.reference_model.description = data.description
    this.reference_model.notes = data.notes
    this.reference_model.admin_notes = data.admin_notes
    this.reference_model.IP = data.IP
    this.jobs_id = data.job_id
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateRef() {
    let body = {
      references: [this.reference_model]
    }
    if (this.reference_id !== '') {
      this.apiService.updateModelManagement(this.jobs_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Reference update successfully')
          this.getJobsById()
          this.modalService.dismissAll()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  deleteRef(password) {
    this.apiService.refDelete(this.reference_id, password).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getJobsById()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }

    })
  }

  // ================== Delete Alert ========================
  confirmDelete(id: any) {
    this.reference_id = id
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteRef(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  onSingleFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.selectedImage = target.files[0];
      this.selectedImages = []; // Clear multiple images
  
      // Read and preview image
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedImage = e.target.result;
      };
      reader.readAsDataURL(this.selectedImage);
    }
  }
  

  // For handling file selection for multiple images
  onMultipleFilesSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      this.selectedImages = Array.from(target.files);
      this.selectedImage = null; // Clear single image

    }

  }

  // Handle switching between single and multiple upload
 switchUploadType(type: 'single' | 'multiple'): void {
    this.selectedUploadType = type;
  }
  // getImagePreview(image: File): string {
  //   return URL.createObjectURL(image);
  // }
  multiImageUpload() {
    const formData = new FormData();
    if (this.selectedImages) {
      for (const image of this.selectedImages) {
        formData.append('photos', image);
         this.apiService.uploadModelManagementImage(this.jobs_id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Multiple images uploaded successfully')
        }
        else {
          this.toastr.error(res.error)
        }
      })
      }
     
    }

  }
  profileImageUpload() {
    const formData = new FormData();
    if (this.selectedImage) {
      console.log('this.selectedImage',this.selectedImage)
        formData.append('image', this.selectedImage);
        this.apiService.uploadModelManagementImage(this.jobs_id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Image uploaded successfully')
        }
        else {
          this.toastr.error(res.error)
        }
      })
      }
      
    }

  selectOwnerId(event){
    this.jobModel.owner = this.selectedowner;
    console.log(this.jobModel.owner);
  }
  selectChecklistId(event){
    this.jobModel.checklist = this.selectedchecklist;
    console.log('this.jobModel.checklist',this.jobModel.checklist);
  }
  selectProjectTagId(event){
    this.jobModel.project_tag = this.selectedproject_tag;
    console.log('this.jobModel.project_tag',this.jobModel.project_tag);
  }
  selectAuditorId(event){
    this.jobModel.auditor = this.selectedauditor;
    console.log(this.jobModel.auditor);
  }
  selectPublisherId(event){
    this.jobModel.publisher = this.selectedpublisher;
    console.log(this.jobModel.publisher);
  }
  selectMarketerId(event){
    this.jobModel.marketer = this.selectedmarketer;
    console.log(this.jobModel.marketer);
  }        
  selectTypeId(event){
      this.jobModel.workon = this.selected_job_type
      console.log(this.jobModel.workon)
    }
 inlineAddupdateBody(data ,prop) {
      if (prop == 'alert_notes') {
        this.jobModel.alert_notes =data
      }
      else if (prop == 'notes') {
        this.jobModel.notes =data
      }
      else if(prop == 'admin_notes') {
        this.jobModel.admin_notes =data
      }
      else if(prop == 'description') {
        this.jobModel.description =data
      }
      else if(prop == 'feature') {
        this.jobModel.feature =data
      }
  
    }
    setFocus(event,prop) {
      event.html
      if (prop == 'alert_notes') {
        if(this.jobs_id)this.jobModel.alert_notes =event.html
        this.modelForm.value.alert_notes =event.html
      }
      else if (prop == 'notes') {
        if(this.jobs_id)this.jobModel.notes =event.html
        this.modelForm.value.notes =event.html
      }
      else if(prop == 'admin_notes') {
        if(this.jobs_id)this.jobModel.admin_notes =event.html
        this.modelForm.value.admin_notes =event.html
        
      }
      else if(prop == 'description') {
        if(this.jobs_id)this.jobModel.description =event.html
        this.modelForm.value.description =event.html

      }
      else if(prop == 'feature') {
        if(this.jobs_id)this.jobModel.feature =event.html
        this.modelForm.value.feature =event.html

      }
      else if(prop == 'domain') {
        if(this.jobs_id)this.jobModel.domain =event.html
        this.modelForm.value.domain =event.html

      }
       else if(prop == 'config_notes') {
        if(this.jobs_id)this.jobModel.config_notes =event.html
        this.modelForm.value.config_notes =event.html

      }
      else if(prop == 'demo_notes') {
        if(this.jobs_id)this.jobModel.demo_notes =event.html
        this.modelForm.value.demo_notes =event.html
        console.log('=>>>',event.html)

      }
    }
  getDevelopment() {
    this.apiService.getTagByTagCatgoryId(this.development_stage_cat_id).subscribe((res: any) => {
      this.development_stage_list = res.data
    })
  }
  getMarket() {
    this.apiService.getTagByTagCatgoryId(this.market_stage_cat_id).subscribe((res: any) => {
      this.market_stage_list = res.data
    })
  }
  getConfig() {
    this.apiService.getTagByTagCatgoryId(this.config_state_cat_id).subscribe((res: any) => {
      this.config_state_list = res.data
    })
  }
  getModelCat() {
    this.apiService.getTagByTagCatgoryId(this.model_cat_id).subscribe((res: any) => {
      this.model_cat_list = res.data
    })
  }
  getModelSource() {
    this.apiService.getTagByTagCatgoryId(this.model_source_cat_id).subscribe((res: any) => {
      this.model_source_list = res.data
    })
  }
  getModelVarient() {
    this.apiService.getTagByTagCatgoryId(this.model_varient_cat_id).subscribe((res: any) => {
      this.model_varient_list = res.data
    })
  }
  getDevelopmentStageId(event){
    this.jobModel.developmentStage  = this.selected_development_stage
    console.log('development',this.selected_development_stage)
  }
  getMarketStageId(event){
    this.jobModel.marketStage  = this.selected_market_stage
    console.log('marketStage',this.selected_market_stage)

  }
  getConfigStateId(event){
    this.jobModel.configState  = this.selected_config_state
    console.log('configState',this.selected_config_state)

  }
  getModelCatId(event){
    // If event is an object, use event._id; if it's a string, use event directly
    const id = event && event._id ? event._id : event;
    this.selected_model_cat = id;
    this.jobModel.modelCat = id;
    this.jobModel.modelCategory = id ? [id] : [];
    console.log('modelCat', id);
    console.log('modelCategory', this.jobModel.modelCategory);
  }

  getModelVarientId(event){
    const id = event && event._id ? event._id : event;
    this.selected_model_varient = id;
    this.jobModel.modelVarient = id;
    this.jobModel.modelVariant = id ? [id] : [];
    console.log('modelVarient', id);
    console.log('modelVariant', this.jobModel.modelVariant);
  }
   getModelSourceId(event){
    this.jobModel.modelSource  = this.selected_model_source
    console.log('modelSource',this.selected_model_source)

  }
  // getModelVarientId(event){
  //   this.jobModel.modelVarient  = this.selected_model_varient
  //   console.log('modelVarient',this.selected_model_varient)

  //   }
}
